// import { NextResponse } from "next/server";
// import {
//   With_AuthAccessRoute,
//   Without_AuthAccessRoute,
//   route,
// } from "./RoutePath";
// import { cookies } from "next/headers";

// export function middleware(request) {
//   //   const url = new URL(request);

//   const token = cookies().get("token")?.value;
//   const reset_otpVerify = cookies().get("forgotPassword_otpverify")?.value;
//   // if(token && )
//   if (token && Without_AuthAccessRoute.includes(request.nextUrl.pathname)) {
//     return NextResponse.redirect(new URL("/", request.url));
//   }

//   if (!token && With_AuthAccessRoute.includes(request.nextUrl.pathname)) {
//     return NextResponse.redirect(new URL("/role", request.url));
//   }

//   if (
//     !token &&
//     !reset_otpVerify &&
//     request.nextUrl.pathname === "/resetpassword"
//   ) {
//     return NextResponse.redirect(new URL("/login", request.url));
//   }
// }

// // export const config = {
// //   matcher: route,
// // };

import { NextResponse } from "next/server";
import { With_AuthAccessRoute, Without_AuthAccessRoute } from "./RoutePath";
import { cookies } from "next/headers";

// export function middleware(request) {
//   const token = cookies().get("token")?.value;
//   const role = cookies().get("role")?.value;
//   const reset_otpVerify = cookies().get("forgotPassword_otpverify")?.value;
//   const { pathname } = request.nextUrl;

//   if (
//     token &&
//     Without_AuthAccessRoute.some((route) => pathname.startsWith(route))
//   ) {
//     return NextResponse.redirect(new URL("/", request.url));
//   }

//   if (
//     !token &&
//     With_AuthAccessRoute?.some((route) => pathname.startsWith(route.path))
//   ) {
//     return NextResponse.redirect(new URL("/role", request.url));
//   }

//   if (!token && !reset_otpVerify && pathname === "/resetpassword") {
//     return NextResponse.redirect(new URL("/login", request.url));
//   }
// }

export function middleware(request) {
  const token = cookies().get("token")?.value;
  const role = cookies().get("role")?.value;
  const reset_otpVerify = cookies().get("forgotPassword_otpverify")?.value;
  const { pathname } = request.nextUrl;

  if (token) {
    if (Without_AuthAccessRoute.some((route) => pathname.startsWith(route))) {
      return NextResponse.redirect(new URL("/", request.url));
    }

    const route = With_AuthAccessRoute.find((r) => pathname.startsWith(r.path));
    if (route) {
      if (route.permission && role !== route.permission) {
        return NextResponse.redirect(new URL(route.redirect, request.url));
      }
    }
  } else {
    if (With_AuthAccessRoute.some((route) => pathname.startsWith(route.path))) {
      return NextResponse.redirect(new URL("/role", request.url));
    }

    if (pathname === "/resetpassword" && !reset_otpVerify) {
      return NextResponse.redirect(new URL("/login", request.url));
    }
  }

  return NextResponse.next();
}

export const config = {
  matcher: [
    // Match all routes except those that should be excluded from the middleware
    "/((?!_next/static|_next/image|favicon.ico).*)",
  ],
};
